import { createContext } from 'react';
import { AuthContextType } from '../context-auth-types';

export const AuthContext = createContext<AuthContextType>(null);
